import type { TaskUser } from '../types/task'

export const mockUsers: TaskUser[] = [
  {
    id: 'u-lucia-ops',
    name: 'Lucia Fernández',
    email: 'lucia@sunday.app',
    role: 'Operations Lead',
    team: 'Operations'
  },
  {
    id: 'u-carlos-bio',
    name: 'Carlos Mendes',
    email: 'carlos@sunday.app',
    role: 'Biologist',
    team: 'Biomass'
  },
  {
    id: 'u-ana-feed',
    name: 'Ana Rodríguez',
    email: 'ana@sunday.app',
    role: 'Feed Specialist',
    team: 'Feed'
  },
  {
    id: 'u-mario-qa',
    name: 'Mario Silva',
    email: 'mario@sunday.app',
    role: 'Quality Assurance',
    team: 'Water'
  }
]
